var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
export var nonPassive = passiveSupported ? { passive: false } : false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
// module id = 809
// module chunks = 0